import { OptionsUrlView } from './options-url-view';

export function createOptionsViewClass({
  i18n,
  model,
}) {
  return class AdvancedOptionsUrlView extends OptionsUrlView {
    initialize(options) {
      super.initialize({
        i18n,
        model,
        options,
      });
    }
  };
}
